import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import cmsUtils from '../../utils/cmsUtils';
import { Item } from '../../items/item';
import utils from '../../../utils';
import { createPortal } from "react-dom";
import './style.scss';
import { SiteLink } from '../../../components';

const localizer = momentLocalizer(moment);

function Portal({ children }) {
    const [el] = useState(document.createElement('div'));
    useEffect(() => {
        let mount = document.getElementById("portal-root");
        mount.appendChild(el);
        return () => mount.removeChild(el);
    }, [el]);
    return createPortal(children, el);
}

function parseDateFromAustralianFormat(dateStr) {
    const [day, month, year] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day); // Month is 0-based
}

const EventComponent = ({ event }) => {
    return (
        <div 
            style={{
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                backgroundColor: event.bgColor,
                borderRadius: '3px',
            }}
            className="rbc-event-content"
        >
            <div style={{
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                lineHeight: '1.2',
                padding: '2px',
                color: `${event.bgColor === '#F6A600' ? '#000' : '#fff'}`,
            }}>
                {event.title}
            </div>
        </div>
    );
}

export function KeyDatesCalendar(props) {
    const item = props.item;
    const subItems = item.items || [];
    const cmsOption = props.cmsOption || {};
    const [isOpen, setIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    console.log("events",subItems);

    const handleClosePopup = useCallback(() => {
        setIsOpen(false);
        setSelectedEvent(null);
        // Re-enable background scroll when popup closes
        document.body.style.overflow = '';
    }, []);

    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
        setIsOpen(true);
        // Disable background scroll when popup opens
        document.body.style.overflow = 'hidden';
    }

    // Cleanup overflow style when component unmounts
    useEffect(() => {
        return () => {
            // Restore scroll when component unmounts
            document.body.style.overflow = '';
        };
    }, []);

    // Handle ESC key to close popup
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                handleClosePopup();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscKey);
        }

        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isOpen, handleClosePopup]);

    const cssClass = utils.classNames('cms_item', 'keyDatesCalendar', item.cssClass || item.anchorName || '');

    const formatDate = {
        agendaDateFormat: 'dddd, D MMMM',
    }

    const formatDated = (date) => {
        const formattedDate = new Date(date).toLocaleString('en-Au', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return formattedDate;
    }

    const myEvents = subItems.map((subItem, index) => {
        return {
            title: subItem.payloads[0].value,
            start: parseDateFromAustralianFormat(subItem.payloads[1].value),
            end: parseDateFromAustralianFormat(subItem.payloads[2].value),
            description: (subItem.payloads[3] && subItem.payloads[3].value) ? subItem.payloads[3].value : subItem.payloads[0].value,
            bgColor: subItem.payloads[4] && subItem.payloads[4].value ? subItem.payloads[4].value : '#002E5B',
            link: subItem.payloads[5] && subItem.payloads[5].value ? subItem.payloads[5].value : null,
            allDay: true,
        }
    });

    return (
        <section
            className={cssClass}
            data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
            id={item.anchorName}
        >
            <Calendar
                formats={formatDate}
                views={['month', 'agenda']}
                localizer={localizer}
                events={myEvents}
                startAccessor="start"
                endAccessor="end"
                onSelectEvent={handleSelectEvent}
                style={{ height: '60vh' }}
                components={{
                    event: EventComponent
                }}
            />
            <div className="notification-tools" style={{ marginTop: '20px' }}>
            </div>
            <Portal>
                {isOpen && selectedEvent && (
                    <div className="popup-overlay" onClick={handleClosePopup}>
                        <div className="popup-content" onClick={e => e.stopPropagation()}>
                            <div className="popup-header">
                                <h3 className="popup-title">{selectedEvent.title}</h3>
                                <button
                                    className="popup-close"
                                    onClick={handleClosePopup}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="popup-body">
                                <div className="event-detail-description">
                                    <span className="detail-label">Description:</span>
                                    <span className="detail-value">
                                        {selectedEvent.description}
                                    </span>
                                </div>
                                <div className="event-detail">
                                    <span className="detail-label">Start Date:</span>
                                    <span className="detail-value">
                                        {formatDated(selectedEvent.start)}
                                    </span>
                                </div>
                                <div className="event-detail">
                                    <span className="detail-label">End Date:</span>
                                    <span className="detail-value">
                                        {formatDated(selectedEvent.end)}
                                    </span>
                                </div>
                                {selectedEvent.link && (
                                    <div className="event-detail-link">
                                        <SiteLink to={selectedEvent.link} target="_blank" rel="noopener noreferrer">View more</SiteLink>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Portal>
        </section>
    );
}